import { useFormField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { Item } from '@calendly/ui/components/menu';
import { EVENT_TYPE_COLOR_I18N_MAP, getEventTypeColorToken } from '@calendly/ui/utils/event-type-colors';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu';
import { useEventType } from 'features/event_type_provider';
import { etEditorMenuLayerStyle } from './et_editor_menu_layer';
import { useETEditorViewportOffset } from '../../../../hooks';
const containerCss = "c2z2z6u";
const containerOpenCss = "c1pzpver";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    isOpen,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, {
    [containerOpenCss]: isOpen
  }, props.className)} />;
});
const styledButtonIsDisabledCss = "s18q4xa5";
const styledButtonCss = "sc9uws";
const StyledButton = forwardRef((props, ref) => {
  const {
    isDisabled,
    ...restProps
  } = props;
  return <BareButton ref={ref} {...restProps} className={classNames(styledButtonCss, {
    [styledButtonIsDisabledCss]: isDisabled
  }, props.className)} />;
});

// i18n-tasks-use t('publisher.event_types.color.red')
// i18n-tasks-use t('publisher.event_types.color.light_pink')
// i18n-tasks-use t('publisher.event_types.color.magenta')
// i18n-tasks-use t('publisher.event_types.color.violet')
// i18n-tasks-use t('publisher.event_types.color.blue')
// i18n-tasks-use t('publisher.event_types.color.cyan')
// i18n-tasks-use t('publisher.event_types.color.lime_green')
// i18n-tasks-use t('publisher.event_types.color.electric_lime')
// i18n-tasks-use t('publisher.event_types.color.bright_yellow')
// i18n-tasks-use t('publisher.event_types.color.orange')
const markerCss = "m1s30f52";
const Marker = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  const markerBackgroundColor = getEventTypeColorToken(color);
  const style = {
    backgroundColor: markerBackgroundColor
  };
  const colorKey = EVENT_TYPE_COLOR_I18N_MAP[color];
  const title = colorKey ? I18n.t(`publisher.event_types.color.${colorKey}`) : '';
  return <Component ref={ref} {...restProps} style={style} title={title} className={classNames(markerCss, props.className)} />;
});
export const ColorPicker = ({
  isLocked,
  showChevron,
  onSelect
}) => {
  const eventType = useEventType();
  const viewportOffset = useETEditorViewportOffset();
  const [toggle, Dropdown, isOpen] = useDropdown();
  const [{
    value: colorValue
  }, _, {
    setValue: setColorValue
  }] = useFormField({
    name: 'color'
  });
  const availableColors = isLocked ? [eventType.color].filter(Boolean) : Object.keys(EVENT_TYPE_COLOR_I18N_MAP);
  const clickable = !isLocked;
  const selectColor = selectedColor => {
    toggle();
    setColorValue(selectedColor);
    if (onSelect) onSelect();
  };
  return <Container id="color-field" isOpen={isOpen}>
      <StyledButton aria-label={I18n.t('publisher.event_types.general.event_color')} aria-expanded={isOpen} onClick={toggle} disabled={!clickable}>
        <Marker color={colorValue} />
        {showChevron && (isOpen ? <ArrowChevronUpMiniIcon /> : <ArrowChevronDownMiniIcon />)}
      </StyledButton>
      <Dropdown>
        <ViewportDropdownMenu pullRight fullWidth viewportOffset={viewportOffset} style={etEditorMenuLayerStyle} mobileMenuStyle={etEditorMenuLayerStyle}>
          {availableColors.map(color => {
          const colorKey = EVENT_TYPE_COLOR_I18N_MAP[color];
          if (!colorKey) return null;
          return <Item key={color} onClick={() => selectColor(color)}>
                <Marker color={color} />
                {I18n.t(`publisher.event_types.color.${colorKey}`)}
              </Item>;
        })}
        </ViewportDropdownMenu>
      </Dropdown>
    </Container>;
};

require("./color_picker.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./color_picker.js");